define([
    'edge/policyjob/services/VinLookupService',
    'edge/policyjob/services/AvailabilityService',
    'edge/policyjob/services/AddressLookupService',
    'customerEdge/policyjob/services/AccountLookupService',
    'customerEdge/policyjob/services/MembershipService',   
    'customerEdge/policyjob/services/ProducerContactService',
    'customerEdge/policyjob/services/ViewDiscountsService',
    'customerEdge/policyjob/services/MVRClueService',
    'customerEdge/policyjob/services/PrefillService',
    'customerEdge/policyjob/services/InMemorySession',
    'customerEdge/policyjob/services/DriverProcessService',
    'customerEdge/policyjob/directives/PaymentDateSelector',
    'customerEdge/policyjob/services/CustomPaymentService',
    'portalConfig',
    'edge/platform/base/module'
], (VinLookupService, AvailabilityService, AddressLookupService, AccountLookupService, MembershipService, ProducerContactService,ViewDiscountsService,MVRClueService,PrefillService,InMemorySession,DriverProcessService,PaymentDateSelector, CustomPaymentService)=> {
    return angular.module('edge.policyjob.app', ['portal.config', 'edge.platform.base'])

        .factory('VinLookupService', VinLookupService)
        .factory('AvailabilityService', AvailabilityService)
        .factory('AddressLookupService', AddressLookupService)
        .factory('AccountLookupService', AccountLookupService)
        .factory('MembershipService', MembershipService)
        .factory('ProducerContactService', ProducerContactService)
        .factory('ViewDiscountsService',ViewDiscountsService)
        .factory('MVRClueService',MVRClueService)
        .factory('PrefillService', PrefillService)
        .factory('InMemorySession', InMemorySession)
        .factory('DriverProcessService', DriverProcessService)
        .factory('CustomPaymentService', CustomPaymentService)

        .directive('gwPaymentDateSelector', PaymentDateSelector)
        .constant('encryptedBase64Key',{
            value:'2b7e151628aed2a6abf7158809cf4f3c'
        });
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/app.js
 **/